// helper file to export the Vuex Store

import Vue from 'vue'
import Vuex from 'vuex'

import { authentication } from './authentication.module'
import { gifts } from './gifts.module'

Vue.use(Vuex)

export const store = new Vuex.Store({
    modules: {
        authentication,
        gifts
    }
})